import { render, staticRenderFns } from "./ifRowContent.vue?vue&type=template&id=ddab2cce&scoped=true&"
import script from "./ifRowContent.vue?vue&type=script&lang=js&"
export * from "./ifRowContent.vue?vue&type=script&lang=js&"
import style0 from "./ifRowContent.vue?vue&type=style&index=0&id=ddab2cce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddab2cce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VChip,VIcon,VList,VListItem,VListItemTitle,VMenu})
